import React from 'react';
import PropTypes from 'prop-types';
import {} from 'ui_system/inputs/checkboxes';
import {
  CheckList,
  Checkbox,
  CheckboxItem,
  CheckboxContent,
  Checkmark,
} from '../styles';

const { object, array, number, string } = PropTypes;

const MultiSelectQuestion = (props) => {
  const {
    answerOptions,
    color,
    field,
    fieldName,
    form,
    bookingId,
    experienceQuestionId,
    guestId,
  } = props;

  const handleToggle = (value) => {
    const values = field.value;
    let newOption;
    if (values) {
      const inList =
        !values?.filter((selected) => selected.questionOptionId === value)
          .length > 0;
      if (inList) {
        newOption = [
          ...values,
          {
            bookingId,
            experienceQuestionId,
            questionOptionId: value,
            id: null,
            guestId,
          },
        ];
      } else {
        newOption = values.filter(
          (selected) => selected.questionOptionId !== value
        );
      }
    } else {
      newOption = [
        {
          bookingId,
          experienceQuestionId,
          questionOptionId: value,
          id: null,
          guestId,
        },
      ];
    }
    form.setFieldValue(fieldName, newOption);
  };
  const values = field.value || [];
  return (
    <CheckList>
      {answerOptions.map((option) => (
        <CheckboxItem
          key={option.value}
          onClick={() => handleToggle(option.value)}
        >
          <Checkbox
            active={
              values.filter(
                (selected) => selected.questionOptionId === option.value
              ).length > 0
            }
            color={color}
          >
            {values.filter(
              (selected) => selected.questionOptionId === option.value
            ).length > 0 && (
              <Checkmark>
                <i className="icon af-checkmark" />
              </Checkmark>
            )}
          </Checkbox>
          <CheckboxContent>{option.label}</CheckboxContent>
        </CheckboxItem>
      ))}
    </CheckList>
  );
};

MultiSelectQuestion.propTypes = {
  value: object,
  answerOptions: array.isRequired,
  color: string,
  fieldName: string.isRequired,
  form: object.isRequired,
  bookingId: number.isRequired,
  experienceQuestionId: number.isRequired,
};

export default MultiSelectQuestion;
